/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveThreadChat } from "../redux/chatSlice";
import { getAuthSession } from "../Helpers/common";
import ChatboardThreadOutgoing from "./chatboardThreadOutgoing";
import ChatboardThreadIncoming from "./chatboardThreadIncoming";
import { clearUnreadThreadCount } from "../Helpers/chatCommon";

const ChatboardThread = () => {
  const dispatch = useDispatch();
  const authSession = getAuthSession();

  const { chat, authUserDetail } = useSelector((state) => state);
  const { authSessionUser } = authUserDetail || {};
  const { unreadThreadListObj, chatRoom, chatMessage, attendeeData } =
    chat || {};

  const activeUnreadThreadList = unreadThreadListObj[chatRoom] || [];

  let senderID = authSession.user_unique_key;

  let incomingUserObj = attendeeData;
  let outgoingUserObj = authSessionUser;

  const getParentMessage = (parentId) => {
    return chatMessage?.find((msg) => msg.id === parentId);
  };

  const handleThreadClick = (v) => {
    const { documentID, parent_id, company_id } = v || {};
    dispatch(
      setActiveThreadChat({
        documentID,
        id: parent_id,
      }),
    );

    clearUnreadThreadCount(documentID, parent_id, company_id);
  };

  return (
    <div className="chat-feed overflow-auto ">
      {activeUnreadThreadList?.map((v, i) => {
        const parentMessage = getParentMessage(v?.parent_id);
        const value = { ...parentMessage, count: v?.count };
        const isOutbound = value?.senderID === senderID;

        if (parentMessage) {
          return (
            <div
              key={i}
              className="cursor-pointer"
              onClick={() => handleThreadClick(v)}
            >
              {isOutbound ? (
                <ChatboardThreadOutgoing
                  value={value}
                  userInfo={outgoingUserObj}
                />
              ) : (
                <ChatboardThreadIncoming
                  value={value}
                  userInfo={incomingUserObj}
                />
              )}
            </div>
          );
        } else {
          return (
            <div
              className="cursor-pointer"
              onClick={() => handleThreadClick(v)}
              key={i}
            >
              <div className="chat_row w-100">
                <div className="w-100 d-flex flex-column max-w-100">
                  <div className="d-flex">
                    <div className="avatar">
                      <svg viewBox="3 2 18 19">
                        <path
                          fill="#425b76"
                          d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                        ></path>
                      </svg>
                    </div>
                    <div className="bubble inner-bubble false">
                      <div className="false">
                        <h3 className="Name-messenger">Thread from User</h3>
                      </div>
                      <div className="d-flex justify-content-between gap-10 align-items-start">
                        <div className="d-flex file_send_info gap-10 flex-wrap">
                          <p className="break-words">Parent message</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-end text-orange cursor-pointer no-whitespace">
                          <span className="chat_count d-flex align-items-center justify-content-center align-self-center mr-2">
                            {v?.count || 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default ChatboardThread;
